// import logo from "./logo.svg";
import "./App.css";
import Main from "./Components/Main";
function App() {
  return (
    <div className="app">
      <Main />
    </div>
  );
}

export default App;
